__webpack_require__.p = "/paprika-yaml/";